
export default {
  // Common
  "language": "言語",
  "language_description": "アプリケーション全体で使用される言語を変更する",
  "save_language": "言語設定を保存",
  "updating": "更新中...",
  "return_home": "ホームに戻る",
  "sign_out": "サインアウト",
  "error": "エラー",
  "loading": "読み込み中...",
  "cancel": "キャンセル",
  "save": "保存",
  "edit": "編集",
  "delete": "削除",
  "back": "戻る",
  "view_details": "詳細を表示",
  "not_applicable": "該当なし",
  "invalid_date": "無効な日付",
  "name": "名前",
  "qty": "数量",
  "actions": "アクション",
  "sort_by": "並び替え",
  "filter_by": "フィルター",
  "ascending": "昇順",
  "descending": "降順",
  "date_added": "追加日",
  "retry": "再試行",
  "with": "使用",
  "or": "または",
  "format": "形式",
  "username": "ユーザー名",
  "phone_number": "電話番号",
  "email": "メールアドレス",
  "change": "変更",
  "save_changes": "変更を保存",
};
